"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _Image = _interopRequireDefault(require("../../Image")),
    _NavigationLink = _interopRequireDefault(require("./NavigationLink")),
    _AdminToggle = _interopRequireDefault(require("./AdminToggle")),
    _navMenu = require("../styles/navMenu");

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var NAV_OPEN_PREF = "navMenuOpen",
    NavigationMenu = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.getNavLinks = (0, _memoizeOne["default"])(function (a) {
      return a.map(d.renderNavLink);
    }), d.toggleMinimiseState = function () {
      d.setState(function (a) {
        var b = a.minimised;
        return {
          minimised: !b
        };
      }, function () {
        var a = d.state.minimised;
        localStorage.setItem(NAV_OPEN_PREF, a ? "true" : "");
      });
    }, d.renderNavLink = function (a) {
      var b = a.label,
          c = a.icon,
          e = a.url,
          f = a.selected,
          g = a.onClick,
          h = a.className,
          i = d.props,
          j = i.history,
          k = i.primaryLinksColour,
          l = i.primaryLinksHoverColour;
      return _react["default"].createElement(_NavigationLink["default"], {
        key: e,
        onClick: g || function () {
          return j.push(e);
        },
        label: b,
        selected: f,
        icon: c,
        className: h,
        linkColour: k,
        linkHoverColor: l
      });
    }, d.goToHome = function () {
      var a = d.props.history;
      a.push("/");
    }, d.state = {
      minimised: !!localStorage.getItem(NAV_OPEN_PREF)
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.topRoutes,
          c = a.bottomRoutes,
          d = a.isExpandable,
          e = a.logoUrl,
          f = a.adminMode,
          g = a.toggleAdminMode,
          h = a.primaryColour,
          i = this.state.minimised;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_navMenu.MENU_CONTAINER, (0, _defineProperty2["default"])({}, _navMenu.MINIMISED_MENU, i))
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])((0, _navMenu.MENU)(h), (0, _defineProperty2["default"])({}, _navMenu.MINIMISED_MENU, i))
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_navMenu.LOGO_CONTAINER)
      }, _react["default"].createElement("button", {
        type: "button",
        onClick: this.goToHome,
        className: _navMenu.LOGO
      }, e ? _react["default"].createElement(_Image["default"], {
        width: "35px",
        height: "35px",
        imageUrl: e,
        backgroundSize: "cover"
      }) : _react["default"].createElement(_Icon["default"], {
        name: "shootstacolour",
        size: 35
      })), _react["default"].createElement(_AdminToggle["default"], {
        adminMode: f,
        toggleAdminMode: g,
        className: _navMenu.MENU_ADMIN_TOGGLE
      })), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_navMenu.TOP_MENU_LINKS)
      }, this.getNavLinks(b)), c ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_navMenu.BOTTOM_MENU_LINKS)
      }, this.getNavLinks(c)) : null, d && this.renderNavLink({
        label: i ? "Expand Menu" : "Collapse Menu",
        icon: i ? "menuexp" : "menucol",
        onClick: this.toggleMinimiseState
      })));
    }
  }]), b;
}(_react.Component);

exports["default"] = NavigationMenu, NavigationMenu.defaultProps = {
  isExpandable: !0
};